// "Store next action" remember??
const asyncMiddleware = store => next => action => {
    
    console.log('action:', action)
    const result = next(action)
    console.log('state after action:', store.getState())
    return result

    // remember that "action" here is just whatever the *thing*
    // was, that was passed to `dispatch()`.
    // So we can check if it was passed a function.
    // In this case, we never call "next" at all.
    // So at this point, nothing else happens unless
    // our action creator dispatches something that is
    // a real action.
    //debugger;
    //if (typeof action === 'function') {
        // Instead, we can *call* the function that was dispatched
        // and instead, pass it the raw dispatch method from the store!
        // Now, our action creator has a reference to the dispatch method
        // and can dispatch whatever else it wants at whatever point
        // it wants to. Or, not at all.
        //return null
    //}
    // if it's not a function, just continue as normal
    
}
export default asyncMiddleware;